import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";
import type {NoticePopup, NoticePopupCollection} from "./ModelTypes.ts";
import axios from "axios";


export class NoticeAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = localization;
    }
}

const apiVersion = 1;

export const notice = {
    async getPopups() {
        try {
            const list = await restfulApiClient.get("popups", apiVersion);
            return list!.data as NoticePopupCollection[]
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new NoticeAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async getPopup(notice_id: number) {
        try {
            const noticeRes = await restfulApiClient.get(`popup/${notice_id}`, apiVersion);
            const notice = noticeRes!.data as NoticePopup;
            if (notice) {
                notice.content = (await axios.get(notice.content_url)).data;
            }
            return notice;
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new NoticeAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },
}